import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export const ImpactStats = ({ stats }) => {
  const { t } = useLang();
  if (!Array.isArray(stats) || stats.length === 0) return null;
  return (
    <section data-testid="impact-stats" className="py-20 lg:py-28 bg-[hsl(160_38%_16%)] text-[hsl(42_33%_96%)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-xs tracking-[0.3em] uppercase font-bold text-[hsl(27_60%_67%)] mb-14">{t("impact.overline")}</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-white/10">
          {stats.map((s, i) => (
            <motion.div key={i}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.12 }}
              className="py-6 sm:py-0 sm:px-10 first:sm:pl-0">
              <div className="font-serif text-6xl lg:text-7xl leading-none text-white">{s.value}</div>
              <div className="mt-3 text-sm text-white/70 tracking-wide">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
